export default "__VITE_ASSET___6jGys5O__"